<!-- First focusable element on every page with a shell: lets keyboard users bypass the masthead and navigation (WCAG 2.2 criterion 2.4.1). Targets the ui-app main landmark, so it is not rendered on the no-shell branch. -->
@if (showShell()) {
  <ui-skip-link></ui-skip-link>
}

<!-- This is a placeholder for custom prime toasts (is it being used?) -->
<app-custom-prime-toast></app-custom-prime-toast>
<phms-terminology-context-menu></phms-terminology-context-menu>

@if (!showShell()) {
  <router-outlet></router-outlet>
}
@else {
  <!-- The is the entire page, including masthead, footer and sidebars -->
  <div class="app-grid-container" [ngClass]="{
    'ez-dev-mode': bitsStateService.devModeSignal(),
    'isBusy': bitsStateService.isBusySignal(),
    'isDev': roles.isDeveloper(),
    'rail-nav-enabled': bitsStateService.navMode() !== 'hamburger'
    }">



    <!--
    Using EZ App which has the grid layout, just supply templates for the header/footer/content
    But in our case, since the footer is not sticky, it is just part of the content.

    Note that sidenav is implemented here and not in Ez App for now but eventually it should
    have a navigation component and we would just feed it the items.
-->
    @if(bitsStateService.useEzApp())
    {

    <!-- This is the side bar AND the main content. The sidebar is toggled by the hamburger menu -->

    <!-- Side bar -->
    <!--
      over - Sidenav floats over the primary content, which is covered by a backdrop
      push - Sidenav pushes the primary content out of its way, also covering it with a backdrop
      side - Sidenav appears side-by-side with the main content, shrinking the main content's width to make space for the sidenav. (auto close doesn't work with this mode)

      Per #20310: the hamburger menu should be expanded "over" the page, from the left side
    -->
    @if (bitsStateService.navMode() === 'hamburger') {
      <mat-sidenav-container class="content app-container h-full">
          <mat-sidenav #sidenav mode="over" [fixedTopGap]="sideNavOffset" fixedBottomGap="0" fixedInViewport="true" class="app-left-sidenav z-30"
              [opened]="bitsStateService.sideNavOpen()" (closed)="bitsStateService.sideNavOpen.set(false)">
              <app-side-nav [sideNav]="sidenav" class="z-30"></app-side-nav>
          </mat-sidenav>

          <mat-sidenav-content>
              <!-- This includes the EZ-App-->
              <ng-container [ngTemplateOutlet]="content"></ng-container>
          </mat-sidenav-content>
      </mat-sidenav-container>
    }
    @else {
      <div class="app-rail-layout h-full">
        <app-side-rail-nav
          [items]="railNavItems()"
          [mode]="bitsStateService.navMode() === 'expanded' ? 'expanded' : 'rail'"
          [offsetTop]="sideNavOffset"
          (modeChanged)="onRailModeChanged($event)"
        ></app-side-rail-nav>

        <div class="app-rail-content h-full">
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </div>
      </div>
    }

    <!-- Header template passed to the ez-app -->
    <ng-template #mastheadTplEzApp>

        <!-- <div>idSignal: {{idSignal()}} commonHeaderExpanded: {{bitsStateService.commonHeaderExpanded()}}, showCaseSummmaryBar: {{ bitsStateService.showCaseSummaryBar()}}</div> -->
        <div class="app-shell-header-stack flex flex-col gap-0">

            <!-- The main header: Hamburger, logo, title, breadcrumbs, My Alerts, Search, Rubik's User menu -->
            <app-masthead></app-masthead>

            <phms-detail-nav-bar [useSharedState]="true"></phms-detail-nav-bar>

            <app-application-banner-host></app-application-banner-host>

            <phms-workflow-context-bar-host></phms-workflow-context-bar-host>

            <!-- <div>CDC Num: <span>{{cdcNumFromChild()}}</span> </div> -->

            <!-- When signaled, show the common header, IP image, name some data buttons, close button style="z-index: 1; position: relative" -->
            <!-- <app-common-header-bar [cdcNum]="cdcNumSignal()" class="z-10" /> -->

            <!-- <app-case-summary-bar *ngIf="caseIdFromChild() && !bitsStateService.commonHeaderExpanded()" class="case-summary-bar-in-header" style="z-index: 2; position: relative;" [caseId]="caseIdFromChild() || ''"/> -->
            <app-case-summary-bar *ngIf="idSignal() && !bitsStateService.commonHeaderExpanded() && bitsStateService.showCaseSummaryBar()"
                class="case-summary-bar-in-header z-20" [caseId]="idSignal() || ''" />

        </div>
    </ng-template>

    <!-- Content template using EzApp -->
    <ng-template #content>
        <ui-app [headerTemplate]="mastheadTplEzApp" [footerTemplate]="bitsStateService.stickyFooter() ? footerTpl : undefined" [ngClass]="appClasses"
            [footerInContent]="!bitsStateService.stickyFooter()">
            <div class="content h-full">
                <mat-drawer-container class="settings-drawer-container h-full">
                    <div class="content-wrapper in-ez-app h-full flex flex-col" [ngClass]="{'summary-bar-expanded': bitsStateService.summaryBarExpanded(),
                  'summary-bar-collapsed': !bitsStateService.summaryBarExpanded(),
                  'common-header-expanded': bitsStateService.commonHeaderExpanded(),
                  'showing-case-summary-bar' : idSignal()
                }" style="z-index: 3;">


                        <!-- Common header is in header. IP Profile-->
                        <!-- TODO: Don't hide this completely if not showing cuz we want to get the data ahead of time. Figure out why the @slideInOut isn't working and fix it -->
                        <div *ngIf="cdcNumSignal() && bitsStateService.commonHeaderExpanded()" class="profile-content-container"
                            [@slideInOut]="bitsStateService.commonHeaderExpanded() ? 'expanded' : 'collapsed'">

                            <!-- <app-ip-profile [cdcNum]="cdcNumSignal()" class="app-pb" /> -->
                        </div>

                        <!-- When signaled, show the case summary bar -->
                        <app-case-summary-bar *ngIf="idSignal() && bitsStateService.commonHeaderExpanded() && bitsStateService.showCaseSummaryBar()"
                            class="case-summary-bar-in-main z-20" [caseId]="idSignal() || ''" />

                        <!-- The case summary workflow -->
                        <!-- <div *ngIf="bitsStateService.enableSummaryBarWorkflowSig() && idSignal()" class="case-summary-background"
                            [@summaryShowHde]="bitsStateService.summaryBarExpanded() ? 'expanded' : 'collapsed'">
                            <hr class="summary-bar" />
                            <app-workflow-table />
                        </div> -->

                        <!-- Detail page, dashboard etc. -->
                        <div id="router-outlet">
                            <router-outlet></router-outlet>
                        </div>

                        <!-- Footer as part of scrollable content when not in sticky mode -->
                        <app-footer *ngIf="!bitsStateService.stickyFooter()" class="footer-in-scrollable-content"></app-footer>
                    </div>

                    <!-- Footer as part of scrollable content -->
                    <!-- <app-footer *ngIf="bitsStateService.footerInContent()" class="footer-in-scrollable-content"></app-footer> -->
                </mat-drawer-container>
            </div>
        </ui-app>
    </ng-template>

    }
    @else
    {
    <!-- Legacy not using EZ App-->

    <!-- The masthead with hamburger menu, logo, breadcrumbs, My Alers, Search, waffle and user menu -->
    <!-- <app-masthead #masthead [sidenav]="sidenav" class="masthead" ></app-masthead> -->
    <ng-container [ngTemplateOutlet]="mastheadTpl"></ng-container>

    <!-- Seems like this would work better but it doesn't because when you drop them down, they're outside of the scrollable-content-->
    <!-- <app-common-header-bar [cdcNum]="cdcNumSignal()" style="z-index: 1; position: relative"/>
  <app-case-summary-bar *ngIf="idSignal() && bitsStateService.showCaseSummaryBar()" class="case-summary-bar-in-header" style="z-index: 2; position: relative;" [caseId]="idSignal()"/> -->

    <!-- This is the side bar AND the main content. The sidebar is toggled by the hamburger menu -->
    @if (bitsStateService.navMode() === 'hamburger') {
      <mat-sidenav-container class="content app-container h-full">
          <!-- Side bar -->
          <!--
        over - Sidenav floats over the primary content, which is covered by a backdrop
        push - Sidenav pushes the primary content out of its way, also covering it with a backdrop
        side - Sidenav appears side-by-side with the main content, shrinking the main content's width to make space for the sidenav. (auto close doesn't work with this mode)

        Per #20310: the hamburger menu should be expanded "over" the page, from the left side
      -->
          <mat-sidenav #sidenav mode="over" [fixedTopGap]="sideNavOffset" fixedBottomGap="0" fixedInViewport="true" class="app-left-sidenav"
              [opened]="bitsStateService.sideNavOpen()">
              <app-side-nav [sideNav]="sidenav"></app-side-nav>
          </mat-sidenav>

          <!-- Main content controlled by side bar -->
          <mat-sidenav-content>

              <div class="content h-full">
                  <mat-drawer-container class="settings-drawer-container">
                      <div class="content-wrapper in-ez-app h-full flex flex-col" [ngClass]="{'summary-bar-expanded': bitsStateService.summaryBarExpanded(),
                'summary-bar-collapsed': !bitsStateService.summaryBarExpanded(),
                'common-header-expanded': bitsStateService.commonHeaderExpanded(),
                'showing-case-summary-bar' : idSignal()
              }" style="z-index: 3;">

                          <!-- Common header is in header. IP Profile-->
                          <!-- TODO: Don't hide this completely if not showing cuz we want to get the data ahead of time. Figure out why the @slideInOut isn't working and fix it -->
                          <div *ngIf="this.cdcNum && bitsStateService.commonHeaderExpanded()" class="profile-content-container"
                              [@slideInOut]="bitsStateService.commonHeaderExpanded() ? 'expanded' : 'collapsed'">

                              <!-- <app-ip-profile [cdcNum]="cdcNumSignal()" class="app-pb" /> -->
                          </div>

                          <!-- When signaled, show the case summary bar -->
                          <app-case-summary-bar *ngIf="idSignal() && bitsStateService.commonHeaderExpanded()" class="case-summary-bar-in-main z-20"
                              [caseId]="idSignal() || ''" />

                          <!-- The case summary workflow -->
                          <!-- <div *ngIf="bitsStateService.enableSummaryBarWorkflowSig() && idSignal()" class="case-summary-background"
                              [@summaryShowHde]="bitsStateService.summaryBarExpanded() ? 'expanded' : 'collapsed'">
                              <hr class="summary-bar" />
                              <app-workflow-table />
                          </div> -->

                          <div id="router-outlet">
                              <router-outlet></router-outlet>
                          </div>

                          <!-- Footer as part of scrollable content -->
                          <ng-container *ngIf="!bitsStateService.stickyFooter()" [ngTemplateOutlet]="footerTpl"></ng-container>

                      </div>
                  </mat-drawer-container>
              </div>

              <!-- Sticky Footer goes here -->
              <ng-container *ngIf="bitsStateService.stickyFooter()" [ngTemplateOutlet]="footerTpl"></ng-container>

          </mat-sidenav-content>
      </mat-sidenav-container>
    }
    @else {
      <div class="app-rail-layout h-full">
        <app-side-rail-nav
          [items]="railNavItems()"
          [mode]="bitsStateService.navMode() === 'expanded' ? 'expanded' : 'rail'"
          [offsetTop]="sideNavOffset"
          (modeChanged)="onRailModeChanged($event)"
        ></app-side-rail-nav>

        <div class="app-rail-content h-full">
          <div class="content h-full">
              <mat-drawer-container class="settings-drawer-container">
                  <div class="content-wrapper in-ez-app h-full flex flex-col" [ngClass]="{'summary-bar-expanded': bitsStateService.summaryBarExpanded(),
            'summary-bar-collapsed': !bitsStateService.summaryBarExpanded(),
            'common-header-expanded': bitsStateService.commonHeaderExpanded(),
            'showing-case-summary-bar' : idSignal()
          }" style="z-index: 3;">

                      <!-- Common header is in header. IP Profile-->
                      <!-- TODO: Don't hide this completely if not showing cuz we want to get the data ahead of time. Figure out why the @slideInOut isn't working and fix it -->
                      <div *ngIf="this.cdcNum && bitsStateService.commonHeaderExpanded()" class="profile-content-container"
                          [@slideInOut]="bitsStateService.commonHeaderExpanded() ? 'expanded' : 'collapsed'">

                          <!-- <app-ip-profile [cdcNum]="cdcNumSignal()" class="app-pb" /> -->
                      </div>

                      <!-- When signaled, show the case summary bar -->
                      <app-case-summary-bar *ngIf="idSignal() && bitsStateService.commonHeaderExpanded()" class="case-summary-bar-in-main z-20"
                          [caseId]="idSignal() || ''" />

                      <!-- The case summary workflow -->
                      <!-- <div *ngIf="bitsStateService.enableSummaryBarWorkflowSig() && idSignal()" class="case-summary-background"
                          [@summaryShowHde]="bitsStateService.summaryBarExpanded() ? 'expanded' : 'collapsed'">
                          <hr class="summary-bar" />
                          <app-workflow-table />
                      </div> -->

                      <div id="router-outlet">
                          <router-outlet></router-outlet>
                      </div>

                      <!-- Footer as part of scrollable content -->
                      <ng-container *ngIf="!bitsStateService.stickyFooter()" [ngTemplateOutlet]="footerTpl"></ng-container>

                  </div>
              </mat-drawer-container>
          </div>

          <!-- Sticky Footer goes here -->
          <ng-container *ngIf="bitsStateService.stickyFooter()" [ngTemplateOutlet]="footerTpl"></ng-container>
        </div>
      </div>
    }

    <!-- Header template-->
    <ng-template #mastheadTpl>
        <div class="app-shell-header-stack flex flex-col gap-0">

            <!-- The main header: Hamburger, logo, title, breadcrumbs, My Alerts, Search, Rubik's User menu -->
            <app-masthead></app-masthead>

            <phms-detail-nav-bar [useSharedState]="true"></phms-detail-nav-bar>

            <app-application-banner-host></app-application-banner-host>

            <phms-workflow-context-bar-host></phms-workflow-context-bar-host>

            <!-- <div>CDC Num: <span>{{cdcNumFromChild()}}</span> </div> -->




        </div>
    </ng-template>
    }

  </div>
}

<!-- Footer template. For ez-app used only in sticky mode -->
<ng-template #footerTpl>
    <div class="app-footer-content">
        <app-footer></app-footer>
    </div>
</ng-template>
